module.exports = __webpack_public_path__ + "img/nav-design-modern@2x.a3ba25e.jpg";